import React, { useEffect, useState } from "react";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import DynamicTable from "../../../components/listing/DynamicTable";
import FiltroRubro from "./FiltroRubro";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";
import CrearRubro from "./CrearRubro";
import EditarRubro from "./EditarRubro";
import EliminarRubro from "./EliminarRubro";

export default function ListarRubro() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [rubroAEditar, setRubroAEditar] = useState(null);
  const [rubroAEliminar, setRubroAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({ codigo: "", nombre: "" });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        console.log("✅ [ListarRubro] useEffect - filtros actuales:", filtros);
        console.log("✅ [ListarRubro] useEffect - página:", pagina, "tamaño:", porPagina);
        const url = apiRoutes.rubros.listUrl({
          page: pagina - 1,
          size: porPagina,
          codigo: filtros.codigo.trim() || undefined,
          nombre: filtros.nombre.trim() || undefined,
        });
        console.log("✅ [ListarRubro] URL generada:", url);

        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando rubros:", e);
        setError("Error al cargar los rubros.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const columns = [
    {
      header: "Código",
      accessor: "codigo",
      type: "text",
      width: "40%",
      cellClass: "text-gray-600 break-words",
    },
    {
      header: "Nombre",
      accessor: "nombre",
      type: "text",
      width: "40%",
      cellClass: "font-medium text-gray-800 break-words",
    },
    {
      header: "Acción",
      type: "action",
      width: "20%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setRubroAEditar(row)}>
  <IconEdit />
</button>
          <button title="Eliminar" onClick={() => setRubroAEliminar(row)}>
  <IconTrash />
</button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Rubros"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => {
          setFiltros({ codigo: "", nombre: "" });
          setPagina(1);
        }}
        showAdd={true}
        addLabel="Agregar"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroRubro
          initialFilters={filtros}
          onSubmit={(nuevos) => {
            console.log("✅ [ListarRubro] onSubmit del filtro - recibidos:", nuevos);
            setFiltros(nuevos);
            setPagina(1);
            setMostrarFiltros(false);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      <DynamicTable size="S" data={data} columns={columns} />

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {mostrarCrear && (
  <CrearRubro
    onClose={() => setMostrarCrear(false)}
    onCreated={() => {
      setPagina(1);
      setReloadKey((k) => k + 1);  // recarga la lista
      setMostrarCrear(false);
    }}
  />
)}

{rubroAEditar && (
  <EditarRubro
    initial={rubroAEditar}
    onClose={() => setRubroAEditar(null)}
    onSaved={() => {
      setReloadKey((k) => k + 1);
      setRubroAEditar(null);
    }}
  />
)}

{rubroAEliminar && (
  <div className="modal-backdrop" onClick={() => setRubroAEliminar(null)}>
    <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
      <EliminarRubro
        registro={rubroAEliminar}
        onClose={() => setRubroAEliminar(null)}
        onDeleted={() => {
          setReloadKey((k) => k + 1);
          setRubroAEliminar(null);
        }}
      />
    </div>
  </div>
)}

    </div>
  );
}